import { endOfDay, isAfter, isBefore, isSameDay, startOfDay } from 'date-fns';
import {
  IOfficeHoursWeekRule,
  IOfficeHoursWeekRuleWithId,
  TDay,
  TOfficeHoursValidity,
} from 'types/e-visits';

/**
 * Get status for office hours rules
 * @param rules rules for office hours
 * @returns array of statuses
 */
export function getOfficeRulesStatuses(
  rules?: (IOfficeHoursWeekRuleWithId | IOfficeHoursWeekRule | undefined)[],
) {
  const res: TOfficeHoursValidity[] = [];
  let preparedCount = 0;
  let activeCount = 0;
  let inactiveCount = 0;

  if (rules) {
    const dayStart = startOfDay(Date.now());
    const dayEnd = endOfDay(Date.now());

    for (const rule of rules) {
      if (!rule) {
        res.push('prepared');
        continue;
      }

      const validFrom = rule.validFrom ? startOfDay(new Date(rule.validFrom)) : undefined;
      const validTo = rule.validTo ? endOfDay(new Date(rule.validTo)) : undefined;

      const noDates = !validFrom && !validTo;
      const onlyTo =
        !validFrom && validTo && (isBefore(dayEnd, validTo) || isSameDay(dayEnd, validTo));
      const onlyFrom =
        validFrom && !validTo && (isBefore(validFrom, dayStart) || isSameDay(validFrom, dayStart));
      const bothDates =
        validFrom &&
        validTo &&
        ((isAfter(dayStart, validFrom) && isBefore(dayEnd, validTo)) ||
          isSameDay(dayEnd, validTo) ||
          isSameDay(validFrom, dayStart));
      const isFuture = validFrom && isAfter(validFrom, dayStart);

      if (noDates || onlyTo || onlyFrom || bothDates) {
        res.push('active');
        activeCount += 1;
      } else if (isFuture) {
        res.push('prepared');
        preparedCount += 1;
      } else {
        res.push('inactive');
        inactiveCount += 1;
      }
    }
  }

  return {
    statuses: res,
    preparedCount,
    activeCount,
    inactiveCount,
  };
}

export function generateEmptyOfficeHour(expertiseCode: string, medicalInstitutionId: string) {
  return {
    days: [...new Array(7).keys()].reduce((acc, key) => {
      acc[key as TDay] = [];
      return acc;
    }, {} as IOfficeHoursWeekRuleWithId['days']),
    expertiseCode,
    medicalInstitutionId,
  };
}
